<input type="hidden" name="menuType" id="menuType" value="public" />

<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <input type="hidden" name="menuType" id="menuType" value="public" />
    <div class="ontario-row">
      <div class="ontario-column ontario-small-12">
        <h2 id="pageTitle"> {{'bss.otpVerify.title' | translate }}</h2>
        <hr>
      </div>
    </div>


    <div *ngIf="!appSuccess && appError" class="ontario-alert ontario-alert--error" aria-live="polite" aria-atomic="true"
      id="pageLevelMessageId" #pageMsg>
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.otpVerify.error' | translate }}</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appErrorMessage | translate"></p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="appSuccess" class="ontario-row">
  <div class="ontario-columns ontario-small-12">

    <div class="ontario-alert ontario-alert--success">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-success"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appSuccessMessage | translate"></p>
      </div>
    </div>
  </div>
</div>

<form ngNoForm [formGroup]="otpForm" [action]='oamSubmitUri' (ngSubmit)="onSubmit()" method='POST' #oamOtpVerifyForm>
  <div class="ontario-row">
    <div class="ontario-column ontario-small-12">

      <p> {{'bss.otpVerify.subtitle' | translate }}</p>
      <p> {{'bss.otpVerify.subtitle2' | translate }}</p>
      <!-- <button tabindex="101" class="ontario-button ontario-button--primary"
        [ngClass]="{'ontario-button--secondary': getOtpClicked}"
        title="{{'bss.otpVerify.button.getOTP.title' | translate }}" (click)="getOTP()" (keyup.enter)="getOTP()"
        [disabled]="getOtpClicked" [ngStyle]="{ 'cursor': getOtpClicked ? 'not-allowed' : 'pointer' }"
        aria-describedby="pageLevelMessageId">
        {{'bss.otpVerify.button.getOTP' | translate }}
      </button> -->


      <label class="ontario-label" for="pin">
        {{'bss.otpVerify.label.pin' | translate }}
      </label>

      <input tabindex="102" class="ontario-input ontario-input--20-char-width" type="text" id="pin"
        title="{{'bss.otpVerify.input.pin.title' | translate }}" formControlName="pin" required minlength="8"
        maxlength="8" aria-describedby="pinError">

      <div class="ontario-alert ontario-alert--error ontario-hide">
        {{'bss.otpVerify.pin.error' | translate }}
      </div>

      <div id="pinError" role="alert" aria-live="assertive"
        *ngIf="(submitted || otpForm.get('pin').touched) && (otpForm.get('pin').errors?.['required'])"
        class="ontario-alert ontario-alert--error">
        <ul>
          <li> {{'bss.otpVerify.pin.error' | translate }}</li>
        </ul>
      </div>
      <div id="pinError" role="alert" aria-live="assertive"
        *ngIf="submitted && (otpForm.get('pin').errors?.['minlength'] || otpForm.get('pin').errors?.['maxlength'] || otpForm.get('pin').errors?.['pattern'])"
        class="ontario-alert ontario-alert--error">
        <ul>
          <li> {{'bss.otpVerify.pin.error.invalid' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>



  <div class="ontario-row">

    <div class="ontario-column ontario-small-12">
      <button tabindex="103" class="ontario-button" [ngClass]="{'ontario-button--primary': !isSubmitting}"
        title="{{'bss.otpVerify.button.submit.title' | translate }}" (click)="onSubmit()" (keyup.enter)="onSubmit()"
        [disabled]="isSubmitting" aria-describedby="pageLevelMessageId">
        {{'bss.otpVerify.button.submit' | translate }}
      </button>

      <p>{{'bss.resend.junk' | translate }}</p>

      <p class="ontario-label__flag">{{'bss.otpVerify.label.resend' | translate }}</p>
      <button tabindex="104" class="ontario-button"
        [ngClass]="{'ontario-button--secondary': !resendDisabled}"
        title="{{'bss.otpVerify.button.resend.title' | translate }}" [disabled]="resendDisabled" (click)="onResend()"
        aria-describedby="pageLevelMessageId">
        {{'bss.otpVerify.button.resend' | translate }}
      </button>
    </div>

    <input formControlName="password" type="hidden" id="password" name="password">
    <input formControlName="username" type="hidden" id="username" name="username">
    <input formControlName="successurl" type="hidden" id="successurl" name="successurl">

  </div>
</form>

<dialog class="ontario-progress" #progressDialog>
  <app-progress></app-progress>
</dialog>